// src/Message/style/index.tsx
import { Keyframes } from "@ant-design/cssinjs";
import { resetComponent } from "antd/es/style";
import { genComponentStyleHook, mergeToken } from "antd/es/theme/internal";
var genMessageStyle = (token) => {
  const {
    componentCls,
    iconCls,
    boxShadowSecondary,
    colorBgElevated,
    colorSuccess,
    colorError,
    colorWarning,
    colorInfo,
    colorLoading,
    fontSizeLG,
    motionEaseInOutCirc,
    motionDurationSlow,
    marginXS,
    paddingXS,
    borderRadiusLG,
    zIndexPopup,
    messageNoticeContentPadding,
    messageNoticeContentBorderColor,
    messageNoticeContentFontWeight,
    messageColor
  } = token;
  const customCls = `${componentCls}-custom`;
  const loadingCircle = new Keyframes("LoadingCircle", {
    "0%": {},
    "100%": {
      transform: "rotate(360deg)"
    }
  });
  const messageMoveIn = new Keyframes("MessageMoveIn", {
    "0%": {
      padding: 0,
      transform: "translateY(-100%)",
      opacity: 0
    },
    "100%": {
      padding: paddingXS,
      transform: "translateY(0)",
      opacity: 1
    }
  });
  const messageMoveOut = new Keyframes("MessageMoveOut", {
    "0%": {
      maxHeight: token.height,
      padding: paddingXS,
      opacity: 1
    },
    "100%": {
      maxHeight: 0,
      padding: 0,
      opacity: 0
    }
  });
  return [
    {
      [componentCls]: {
        ...resetComponent(token),
        position: "fixed",
        top: marginXS,
        width: "100%",
        pointerEvents: "none",
        zIndex: zIndexPopup,
        color: messageColor,
        [`${componentCls}-move-up`]: {
          animationFillMode: "forwards"
        },
        [`
        ${componentCls}-move-up-appear,
        ${componentCls}-move-up-enter
      `]: {
          animationName: messageMoveIn,
          animationDuration: motionDurationSlow,
          animationPlayState: "paused",
          animationTimingFunction: motionEaseInOutCirc
        },
        [`
        ${componentCls}-move-up-appear${componentCls}-move-up-appear-active,
        ${componentCls}-move-up-enter${componentCls}-move-up-enter-active
      `]: {
          animationPlayState: "running"
        },
        [`${componentCls}-move-up-leave`]: {
          animationName: messageMoveOut,
          animationDuration: motionDurationSlow,
          animationPlayState: "paused",
          animationTimingFunction: motionEaseInOutCirc
        },
        [`${componentCls}-move-up-leave${componentCls}-move-up-leave-active`]: {
          animationPlayState: "running"
        },
        "&-rtl": {
          direction: "rtl",
          span: {
            direction: "rtl"
          }
        }
      }
    },
    {
      [`${componentCls}-notice`]: {
        padding: paddingXS,
        textAlign: "center",
        [iconCls]: {
          verticalAlign: "text-bottom",
          marginInlineEnd: marginXS,
          fontSize: fontSizeLG
        },
        [`${componentCls}-notice-content`]: {
          display: "inline-block",
          padding: messageNoticeContentPadding,
          border: `1px solid ${messageNoticeContentBorderColor}`,
          background: colorBgElevated,
          borderRadius: borderRadiusLG,
          boxShadow: boxShadowSecondary,
          fontWeight: messageNoticeContentFontWeight,
          pointerEvents: "all",
          maxWidth: "480px",
          textAlign: "left",
          [`${componentCls}-custom-content`]: {
            display: "flex",
            alignItems: "flex-start",
            [`${customCls}-icon`]: {
              marginTop: "3px",
              marginRight: "8px",
              lineHeight: 0
            },
            [`${customCls}-icon-loading svg`]: {
              animationName: loadingCircle,
              animationDuration: "1s",
              animationIterationCount: "infinite",
              animationTimingFunction: "linear"
            }
          }
        },
        [`${componentCls}-success ${iconCls}`]: {
          color: colorSuccess
        },
        [`${componentCls}-error ${iconCls}`]: {
          color: colorError
        },
        [`${componentCls}-warning ${iconCls}`]: {
          color: colorWarning
        },
        [`
        ${componentCls}-info ${iconCls}`]: {
          color: colorInfo
        },
        [`
        ${componentCls}-loading ${iconCls}`]: {
          color: colorLoading
        }
      },
      [`${componentCls}-rtl`]: {
        [`${componentCls}-notice`]: {
          [`${componentCls}-notice-content`]: {
            textAlign: "right",
            [`${componentCls}-custom-content`]: {
              [`${customCls}-icon`]: {
                marginRight: "0",
                marginLeft: "8px"
              }
            }
          }
        }
      }
    },
    {
      [`${componentCls}-notice-pure-panel`]: {
        padding: 0,
        textAlign: "start"
      }
    }
  ];
};
var style_default = genComponentStyleHook(
  "Message",
  (token) => {
    const combinedToken = mergeToken(token, {
      messageNoticeContentPadding: `12px 16px`,
      messageNoticeContentBorderColor: "var(--bds-gray-ele-line)",
      colorBgElevated: "var(--bds-gray-bg-card)",
      boxShadowSecondary: "var(--bds-shadow-l1)",
      messageColor: "var(--bds-gray-t1-title)",
      messageNoticeContentFontWeight: "var(--bds-font-weight-medium)",
      colorSuccess: "var(--bds-green-700-normal)",
      colorError: "var(--bds-red-700-normal)",
      colorWarning: "var(--bds-red-700-normal)",
      colorInfo: "var(--bds-brand-700-normal)",
      colorLoading: "var(--bds-gray-t2)",
      paddingXS: 4
    });
    return [genMessageStyle(combinedToken)];
  },
  (token) => ({
    height: 150,
    zIndexPopup: token.zIndexPopupBase + 10
  })
);
export {
  style_default as default
};
